export default {
  header: 'Wandas',
  noWandasFound: {
    header: 'No Devices Found',
    context: 'Try a different device ID or location',
  },
  search: 'Search by ID or location',
  wandaStatusTable: {
    headers: {
      status: 'Status',
      id: 'Id',
      venue: 'Venue',
      lastActivity: 'Last Activity',
    },
    row: {
      activeStatusTime: {
        neverActive: '-',
        now: 'Now',
        recentlyActive: '%minutes% min ago',
        beyondThreshold: '> 20 min ago',
      },
      venueTooltip: 'Device is setup to operate at any of your venues, assigning a location is recommended.',
      anyLocation: 'Any Location',
      online: 'online',
      offline: 'offline',
      allVenues: 'All Venues',
    },
  },
  modal: {
    changeVenue: 'Change Venue',
  },
};
